import { render, staticRenderFns } from "./SettlementStatus.vue?vue&type=template&id=07218ac5"
import script from "./SettlementStatus.vue?vue&type=script&lang=js"
export * from "./SettlementStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports